import React from "react";

import InputText from "@app/components/2_widgets/inputs/InputText";
import { apiCall } from '@app/utils/apiCall';
import { useCustomer } from "@app/contexts/CustomerContext";
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import { useAuth } from '@app/contexts/AuthContext';
import { buildStructureFormDataBuilder } from "@app/utils/form_data_builders/StructureFormDataBuilder";
import { Trash2 } from "lucide-react";

export default function DossierPDLInputs({structureData}) {    
    const structure = structureData.structure? structureData.structure : {};
    const dossier = useDossier();
    const dossierDispatch = useDossierDispatch();
    
    const auth = useAuth();
    
    function reloadDossier() {
        apiCall ({
            method: "get",
            path: `/api/v1/dossiers/${dossier.id}`,
            auth: auth,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });
            }
        });
    }

    function updateStructure(key, value) {
        if (structure.id) {
            structure[key] = value;
            
            const formData = buildStructureFormDataBuilder(structure);
            
            apiCall({
                method: "patch",
                path: `/api/v1/structures/${structure.id}`,
                auth: auth,
                data: formData,
                onSuccess: (response) => {}
            });
        }
    }

    function destroyPDL(event) {
        event.preventDefault();

        const formData = new FormData();
        formData.append("structure_data_id", structureData.id);

        apiCall({
            method: "delete",
            path: `/api/v1/structures/${structure.id}`,            
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                reloadDossier();
            }
        });
    }

    return (
        <div>
            <div className="row row-input align-items-center">
                <div className="col-2">
                    <InputText
                        inputId={`text-tradename-${structureData.id}`}
                        label="Nom du site"
                        defaultValue={structure.trade_name}
                        placeholder="Site X"
                        callbackBlur={(error, value) => updateStructure("trade_name", value)}
                    />
                </div>
                <div className="col-2">
                    <InputText
                        inputId={`text-siret-${structureData.id}`}
                        label="SIRET"
                        defaultValue={structure.siret}
                        placeholder="81100000000000"
                        callbackBlur={(error, value) => updateStructure("siret", value)}
                    />
                </div>
                <div className="col-2">
                    <InputText
                        inputId={`text-plm-${structureData.id}`}
                        label="PDL"
                        defaultValue={structure.plm_number}
                        placeholder="000000000"
                        callbackBlur={(error, value) => updateStructure("plm_number", value)}
                    />
                </div>
                <div className="col-2">
                    <InputText
                        inputId={`text-address-${structureData.id}`}
                        label="Adresse"
                        defaultValue={structure.address}
                        placeholder="1 rue de Brest"
                        callbackBlur={(error, value) => updateStructure("address", value)}
                    />
                </div>
                <div className="col-1">
                    <InputText
                        inputId={`text-zipcode-${structureData.id}`}
                        label="Code postal"
                        defaultValue={structure.postal_code}
                        placeholder="29000"
                        callbackBlur={(error, value) => updateStructure("postal_code", value)}
                    />
                </div>
                <div className="col-2">
                    <InputText
                        inputId={`text-city-${structureData.id}`}
                        label="Ville"
                        defaultValue={structure.city}
                        placeholder="Quimper"
                        callbackBlur={(error, value) => updateStructure("city", value)}
                    />
                </div>
                <div className="col-1">
                    <div onClick={destroyPDL} className="default-icon red mt-4"><Trash2 className="clickable" /></div>
                </div>
            </div>
        </div>
    )
}